export default [
  {
    title: 'Dashboards',
    icon: 'TrendingUpIcon',
    // tag: '2',
    tagVariant: 'light-warning',
    route: 'dashboard',
    resource: 'dashboard',
    action: 'view',
    // children: [
    //   {
    //     title: 'eCommerce',
    //     route: 'dashboard-ecommerce',
    //   },
    //   {
    //     title: 'Analytics',
    //     route: 'dashboard-analytics',
    //   },
    // ],
  },
]
